import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import { FormAmiantoGiudizialeComponent } from "./form-amianto-giudiziale/form-amianto-giudiziale.component";
import {
  FormAmiantoGiudizialeViewComponent
} from "./form-amianto-giudiziale/view/form-amianto-giudiziale-view.component";
import { FormAmiantoComponent } from "./form-amianto/form-amianto.component";
import { FormAmiantoViewComponent } from "./form-amianto/view/form-amianto-view.component";
import { FormArbitratoComponent } from './form-arbitrato/form-arbitrato.component';
import { FormArbitratoViewComponent } from "./form-arbitrato/view/form-arbitrato-view.component";
import { FormAzioneMonitoriaComponent } from './form-azione-monitoria/form-azione-monitoria.component';
import { FormAzioneMonitoriaViewComponent } from "./form-azione-monitoria/view/form-azione-monitoria-view.component";
import { FormAzioneRevocatoriaComponent } from "./form-azione-revocatoria/form-azione-revocatoria.component";
import {
  FormAzioneRevocatoriaViewComponent
} from "./form-azione-revocatoria/view/form-azione-revocatoria-view.component";
import { FormCautelareComponent } from './form-cautelare/form-cautelare.component';
import { FormCautelareViewComponent } from "./form-cautelare/view/form-cautelare-view.component";
import { FormCoterziComponent } from './form-coterzi/form-coterzi.component';
import { FormCoterziViewComponent } from "./form-coterzi/view/form-coterzi-view.component";
import { FormEsecuzioneComponent } from "./form-esecuzione/form-esecuzione.component";
import { FormEsecuzioneViewComponent } from "./form-esecuzione/view/form-esecuzione-view.component";
import { FormImmobiliareComponent } from './form-immobiliare/form-immobiliare.component';
import { FormImmobiliareViewComponent } from "./form-immobiliare/view/form-immobiliare-view.component";
import { FormMediazioneComponent } from './form-mediazione/form-mediazione.component';
import { FormMediazioneViewComponent } from "./form-mediazione/view/form-mediazione-view.component";
import { FormMobiliareComponent } from './form-mobiliare/form-mobiliare.component';
import { FormMobiliareViewComponent } from "./form-mobiliare/view/form-mobiliare-view.component";
import {
  FormNegoziazioneAssistitaComponent
} from './form-negoziazione-assistita/form-negoziazione-assistita.component';
import {
  FormNegoziazioneAssistitaViewComponent
} from "./form-negoziazione-assistita/view/form-negoziazione-assistita-view.component";
import {
  FormOpposizioneAttiEsecutiviComponent
} from './form-opposizione-atti-esecutivi/form-opposizione-atti-esecutivi.component';
import {
  FormOpposizioneAttiEsecutiviViewComponent
} from "./form-opposizione-atti-esecutivi/view/form-opposizione-atti-esecutivi-view.component";
import {
  FormOpposizioneDecretoIngiuntivoComponent
} from './form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component';
import {
  FormOpposizioneDecretoIngiuntivoViewComponent
} from "./form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component";
import {
  FormOpposizioneEsecuzioneComponent
} from './form-opposizione-esecuzione/form-opposizione-esecuzione.component';
import {
  FormOpposizioneEsecuzioneViewComponent
} from "./form-opposizione-esecuzione/view/form-opposizione-esecuzione-view.component";
import { FormOpposizionePrecettoComponent } from './form-opposizione-precetto/form-opposizione-precetto.component';
import {
  FormOpposizionePrecettoViewComponent
} from "./form-opposizione-precetto/view/form-opposizione-precetto-view.component";
import { FormOrdinarioComponent } from './form-ordinario/form-ordinario.component';
import { FormOrdinarioViewComponent } from './form-ordinario/view/form-ordinario-view.component';
import { FormPrecettoComponent } from './form-precetto/form-precetto.component';
import { FormPrecettoViewComponent } from "./form-precetto/view/form-precetto-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from './form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "./form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import { FormRicorsoLavoroComponent } from "./form-ricorso-lavoro/form-ricorso-lavoro.component";
import { FormRicorsoLavoroViewComponent } from "./form-ricorso-lavoro/view/form-ricorso-lavoro-view.component";
import { FormRicorsoAmministrativoComponent } from './form-ricorso/form-ricorso.component';
import { FormRicorsoAmministrativoViewComponent } from './form-ricorso/view/form-ricorso-view.component';
import { FormSinistroSanitarioComponent } from './form-sinistro-sanitario/form-sinistro-sanitario.component';
import {
  FormSinistroSanitarioViewComponent
} from './form-sinistro-sanitario/view/form-sinistro-sanitario-view.component';
import { FormSommarioUrgenzaComponent } from './form-sommario-urgenza/form-sommario-urgenza.component';
import { FormSommarioUrgenzaViewComponent } from "./form-sommario-urgenza/view/form-sommario-urgenza-view.component";
import { FormSpecialeComponent } from './form-speciale/form-speciale.component';
import { FormSpecialeViewComponent } from "./form-speciale/view/form-speciale-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';
import { FormGenericoComponent } from './form-generico/form-generico.component';


@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormArbitratoComponent,
        FormArbitratoViewComponent,
        FormAzioneMonitoriaComponent,
        FormAzioneMonitoriaViewComponent,
        FormCautelareComponent,
        FormCautelareViewComponent,
        FormCoterziComponent,
        FormCoterziViewComponent,
        FormImmobiliareComponent,
        FormImmobiliareViewComponent,
        FormMediazioneComponent,
        FormMediazioneViewComponent,
        FormMobiliareComponent,
        FormMobiliareViewComponent,
        FormNegoziazioneAssistitaComponent,
        FormNegoziazioneAssistitaViewComponent,
        FormOpposizioneAttiEsecutiviComponent,
        FormOpposizioneAttiEsecutiviViewComponent,
        FormOpposizioneDecretoIngiuntivoComponent,
        FormOpposizioneDecretoIngiuntivoViewComponent,
        FormOpposizioneEsecuzioneComponent,
        FormOpposizioneEsecuzioneViewComponent,
        FormOpposizionePrecettoComponent,
        FormOpposizionePrecettoViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
        FormPrecettoComponent,
        FormPrecettoViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormSommarioUrgenzaComponent,
        FormSommarioUrgenzaViewComponent,
        FormSpecialeComponent,
        FormSpecialeViewComponent,
        FormAmiantoComponent,
        FormAmiantoViewComponent,
        FormAmiantoGiudizialeComponent,
        FormAmiantoGiudizialeViewComponent,
        FormRicorsoLavoroComponent,
        FormRicorsoLavoroViewComponent,
        FormSinistroSanitarioComponent,
        FormSinistroSanitarioViewComponent,
        FormAzioneRevocatoriaComponent,
        FormAzioneRevocatoriaViewComponent,
        FormEsecuzioneComponent,
        FormEsecuzioneViewComponent,
        FormRicorsoAmministrativoComponent,
        FormRicorsoAmministrativoViewComponent
    ],
    providers: [DynamicComponentService],
    exports: [
        FormArbitratoComponent,
        FormArbitratoViewComponent,
        FormAzioneMonitoriaComponent,
        FormAzioneMonitoriaViewComponent,
        FormCautelareComponent,
        FormCautelareViewComponent,
        FormCoterziComponent,
        FormCoterziViewComponent,
        FormImmobiliareComponent,
        FormImmobiliareViewComponent,
        FormMediazioneComponent,
        FormMediazioneViewComponent,
        FormMobiliareComponent,
        FormMobiliareViewComponent,
        FormNegoziazioneAssistitaComponent,
        FormNegoziazioneAssistitaViewComponent,
        FormOpposizioneAttiEsecutiviComponent,
        FormOpposizioneAttiEsecutiviViewComponent,
        FormOpposizioneDecretoIngiuntivoComponent,
        FormOpposizioneDecretoIngiuntivoViewComponent,
        FormOpposizioneEsecuzioneComponent,
        FormOpposizioneEsecuzioneViewComponent,
        FormOpposizionePrecettoComponent,
        FormOpposizionePrecettoViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
        FormPrecettoComponent,
        FormPrecettoViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormSinistroSanitarioComponent,
        FormSinistroSanitarioViewComponent,
        FormSommarioUrgenzaComponent,
        FormSommarioUrgenzaViewComponent,
        FormSpecialeComponent,
        FormSpecialeViewComponent,
        FormAmiantoComponent,
        FormAmiantoViewComponent,
        FormAmiantoGiudizialeComponent,
        FormAmiantoGiudizialeViewComponent,
        FormRicorsoLavoroComponent,
        FormRicorsoLavoroViewComponent,
        FormAzioneRevocatoriaComponent,
        FormAzioneRevocatoriaViewComponent,
        FormEsecuzioneComponent,
        FormEsecuzioneViewComponent,
        FormRicorsoAmministrativoComponent,
        FormRicorsoAmministrativoViewComponent
    ]
})
export class FascicoloFormSharedModule {

}
